import React from "react";
import ProductService from "../../services/product.service";
import {CButton, CSpinner} from "@coreui/react";
import HistoryProduct from "./HistoryProduct";
import ModalEan from "../modals/EanProduct";
import {StateContext} from "../context/StateProvider";
import Toasts from "../notificacion/Toasts";
import InventoryProduct from "./InventoryProduct";
import ReportProblem from "@mui/icons-material/ReportProblem";
import Utils from "../../utils/Utils";
import AuthService from "../../services/auth.service";
import Roles from "../../config/roles";


class Product extends React.Component {

    static contextType = StateContext;

    /**
     * Seleccionar producto
     * @param index
     */
    handleSelectProduct(index) {

        const {state, updateState} = this.context;

        if (state.products[index].checked === undefined || state.products[index].checked === false)
            state.products[index].checked = true;
        else
            state.products[index].checked = false;

        updateState({products: state.products})
    }

    /**
     * Actualizar producto
     * @param index
     * @param recovery
     */
    handleUpdateProduct(index, recovery) {

        const {state, updateState} = this.context;

        if (Object.keys(state.products[index].updated).length !== 0 || recovery) {
            ProductService.updateProduct(state.products[index].ref, state.products[index].updated, recovery).then(
                result => {

                    if (result.data) {

                        if (result.data.actualizado && state.products[index].updated.ubicacion) {
                            state.products[index].revert = true;
                        }

                        if (recovery) {
                            state.products[index].location = result.data.ubicacion;
                            state.products[index].revert = false;
                        }
                    }

                    const toasts = Toasts.generateToast(result.message, 'success');
                    state.products[index].updated = {};
                    updateState({products: state.products});
                    updateState({toasts: [...state.toasts, toasts]})
                }
            ).catch((error) => {
                const toasts = Toasts.generateToast(error.response?.data?.message, 'error');
                updateState({toasts: [...state.toasts, toasts]})
                updateState({products: state.products});
            });
        }
    }

    /**
     * Mostrar historico de ubicaciones
     * @param index
     */
    handleHistoryLocation(index) {

        const {state, updateState} = this.context;

        if (state.products[index].showHistory === true) {
            state.products[index].showHistory = false;
            updateState({products: state.products});
        } else {
            ProductService.getProductHistory(state.products[index].ref).then(
                result => {
                    if (result.length === 0) {
                        const toasts = Toasts.generateToast('No hay histórico de producto', 'warning');
                        updateState({toasts: [...state.toasts, toasts]})
                        state.products[index].showHistory = false;
                    } else {
                        state.products[index].showHistory = true;
                    }

                    state.products[index].history = result;
                    updateState({products: state.products});
                }
            ).catch((error) => {
                const toasts = Toasts.generateToast(error.response?.data?.message, 'error');
                updateState({toasts: [...state.toasts, toasts]})
                updateState({products: state.products});
            });
        }
    }

    /**
     * Mostrar historico de inventario
     * @param index
     */
    handleHistoryInventory(index) {

        const {state, updateState} = this.context;

        if (state.products[index].showInventory === true) {
            state.products[index].showInventory = false;
        } else {
            state.products[index].showInventory = true;
        }

        updateState({products: state.products});
    }

    /**
     * Actualizar ubicacion
     * @param event
     * @param index
     */
    handleChangeLocation(event, index) {

        const {state, updateState} = this.context;

        state.products[index].location = event.target.value;
        state.products[index].updated.ubicacion = event.target.value;

        updateState({products: state.products});
    }

    handleCheckStock(e, index, warehouse, stock, productRef) {
        const {state, updateState} = this.context;
        ProductService.registerProductInventory(productRef, warehouse, stock).then(
            result => {
                state.products[index].inventory.unshift({'almacen': warehouse, 'stock': stock, 'productRef': productRef, 'fecha': result.fecha});
                updateState({products: state.products});
            }
        ).catch((error) => {
            const toasts = Toasts.generateToast(error.response?.data?.message, 'error');
            updateState({toasts: [...state.toasts, toasts]})
            updateState({products: state.products});
        });
    }

    checkStockHistory(index, warehouse, stock) {
        const { state } = this.context;

        // Check if the product or inventory exists
        if (!state.products[index] || !state.products[index].inventory) return false;

        let productoMasReciente = null;

        for (const item of state.products[index].inventory) {
            if (item.almacen === warehouse) {
                if (!productoMasReciente || new Date(item.fecha) > new Date(productoMasReciente.fecha)) {
                    productoMasReciente = item; // Update the most recent product
                }
            }
        }

        if (!productoMasReciente) return false;

        return productoMasReciente.stock === stock;
    }

    /**
     * Obtener imagen
     * @param images
     * @returns {string}
     */
    getImageProduct(images) {

        if (images !== undefined) {
            const index = images.findIndex(
                (image) => {
                    return image.ORDEN === true;
                }
            );
            if (index !== -1) {
                return ProductService.generateImageUrl(images[index].IMAGEN.toLowerCase());
            }

            return ProductService.generateImageUrl('not-found')
        }
    }

    render() {

        const {index, update, select, inventory = false, handleNote} = this.props;
        const {state, getNombreAlmacen} = this.context;
        const product = state.products[index];
        const user = AuthService.getCurrentUser();

        return (
            <li className="list-group-item border-top">
                <div className="flex-column flex-lg-row pt-3 pb-3">
                    <div className="row">
                        <div
                            className="list-image-product text-center col-12 col-sm-3 order-sm-2 aspect-ratio aspect-ratio-4x3">
                            <img src={this.getImageProduct(product.images)}
                                 className="img-fluid h-100 aspect-ratio-item" alt={product.name}/>
                        </div>
                        <div className="col-12 col-sm-9 order-sm-1">
                            {select==="1" ?
                                <input type="checkbox"
                                       checked={product.checked} onChange={() => {
                                    this.handleSelectProduct(index)
                                }}/>
                                : ''}
                            <div className="row">
                                <div className="col-12 d-inline-flex align-items-center">
                                    <label className="form-label mb-2 me-2">Nombre:</label>
                                    <div className="form-text mt-0 mb-2">{product.name}</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 d-inline-flex align-items-center">
                                    <label className="form-label mb-2 me-2">Referencia:</label>
                                    <div className="form-text mt-0 mb-2">{product.ref}</div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-12 d-inline-flex align-items-center">
                                    <label className="form-label mb-2 me-2">Código barras:</label>
                                    {product.ean.length > 0 !== '' ?
                                        <div className="form-text mt-0 mb-2">
                                            {product.ean?.map((item, index) => {
                                                return (<span key={index}>{item.BARRAS}-{item.UNIDADES}</span>)
                                            })}
                                        </div>
                                        : ''}
                                    {update === "1" ?
                                        <ModalEan index={index}/>
                                        : ''}
                                </div>
                            </div>
                            {user.roles.includes(Roles.MARKETING.role) || user.roles.includes(Roles.ADMIN.role) ?
                                <>
                                    <div className="row">
                                        <div className="col-12 d-inline-flex align-items-center">
                                            <label className="form-label mb-2 me-2">Descripcion:</label>
                                            <div
                                                className="form-text mt-0 mb-2"
                                                style={{ whiteSpace: "pre-line" }}
                                            >
                                                {product.descripcion}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 d-inline-flex align-items-center">
                                            <label className="form-label mb-2 me-2">Marca:</label>
                                            <div className="form-text mt-0 mb-2">{product.marca}</div>
                                        </div>
                                    </div>
                                </>
                                : ''
                            }
                            {
                                product.fields?.length > 0 && product.fields?.map((item, index) => {
                                    return (
                                        <div key={index}
                                             className={(item.CAMPO === '117' || item.CAMPO === '118') && (item.VALOR === '' || item.VALOR === '0') ? 'd-none' : 'row'}>
                                            <div className="col-12 d-inline-flex align-items-center">
                                                <label className="form-label mb-2 me-2">
                                                    {item.CAMPO === '###' ? 'Publicado web:' : ''}
                                                    {item.CAMPO === '117' ? 'Caja individual:' : ''}
                                                    {item.CAMPO === '118' ? 'Caja grande:' : ''}
                                                </label>
                                                <div className="form-text mt-0 mb-2">
                                                    {item.CAMPO === '###' ? item.VALOR === '.T.' ? 'No' : 'Si' : ''}
                                                    {(item.CAMPO === '117' || item.CAMPO === '118') ? item.VALOR : ''}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {!user.roles.includes(Roles.MARKETING.role) ?
                                <>
                                    {
                                        product.stock?.length > 0 && product.stock?.map((item, indexProduct) => {
                                            return (
                                                <div key={indexProduct} className="row">
                                                    <div className={`col-12 d-inline-flex align-items-center ${inventory ? 'mt-2' : ''}`}>
                                                        <label className="form-label mb-2 me-2">Stock {getNombreAlmacen(item.ALMACEN)}:</label>
                                                        <div className="form-text mt-0 mb-2">
                                                            {item.FINAL}
                                                        </div>
                                                        {inventory && !this.checkStockHistory(index, item.ALMACEN, item.FINAL) ?
                                                            <CButton onClick={(e) => this.handleCheckStock(e, index, item.ALMACEN, item.FINAL, product.ref)} color="primary" className="px-2 ms-3">
                                                                Stock comprobado
                                                            </CButton>
                                                            : ''}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    {product.replace > 0 ?
                                        <div className="row">
                                            <div className="col-12 d-inline-flex align-items-center">
                                                <label className="form-label mb-2 me-2">Reponer nave 1:</label>
                                                <div className="form-text mt-0 mb-2">{product.replace}</div>
                                            </div>
                                        </div>
                                        : ''}
                                    <div className="row">
                                        <div className="col-12 d-inline-flex align-items-center">
                                            <label className="form-label mb-1 me-2">Ubicación:</label>
                                            {update === "1" ?
                                                <input className="form-control mt-0 mb-1 p-1" type="text" value={product.location}
                                                       onChange={(e) => this.handleChangeLocation(e, index)}/>
                                                : <div className="form-text mt-0 mb-1"> {product.location}</div>}
                                        </div>
                                    </div>
                                    {inventory ?
                                        <div className='row'>
                                            <div
                                                className="col-12 d-inline-flex align-items-center mt-1">
                                                <label htmlFor="expedition" className="form-label mb-1 me-2">Incidencia</label>
                                                <div className="form-text mt-0 mb-1">
                                                    <CButton onClick={() => handleNote(product.ref)} type="button" className="btn btn-link" variant="ghost" >
                                                        incidencia
                                                    </CButton>
                                                    {product.Note !== undefined && product.Note.albaran !== undefined && product.Note.estado !== 3 ? <ReportProblem color='warning' /> : ''}
                                                </div>
                                            </div>
                                        </div>
                                        : ''}
                                    {
                                        product.HistoricoVentas?.length > 0 && (
                                            <div className="row mt-2">
                                                <div className="col-12">
                                                    <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                                                        <label className="form-label mb-0 text-nowrap">
                                                            Salidas:
                                                        </label>
                                                        <div
                                                            className="d-flex gap-2 overflow-auto"
                                                            style={{ scrollbarWidth: 'thin' }}
                                                        >
                                                            {product.HistoricoVentas.map((venta, indexVenta) => (
                                                                <div
                                                                    key={indexVenta}
                                                                    className="badge badge-grid text-nowrap p-2"
                                                                    style={{ flexShrink: 0 }}
                                                                >
                                                            <span className="me-1">
                                                              {Utils.getNombreMes(venta.mes)}:
                                                            </span>
                                                                    <span className="fw-bold">
                                                              {venta.unidades_total}
                                                            </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                </>
                           : '' }
                        </div>
                    </div>
                    {!user.roles.includes(Roles.MARKETING.role) ?
                    <div className="mt-3 product-action">
                        <div className="text-start">
                            {update === "1" ?
                                <CButton className="btn btn-primary" onClick={() => {
                                    this.handleUpdateProduct(index, false)
                                }}>Actualizar
                                </CButton>
                            : ''}
                            <CButton className="btn btn-secondary" onClick={() => {
                                this.handleHistoryLocation(index)
                            }}>Ver histórico ubicaciones
                            </CButton>
                            {product.revert !== undefined && product.revert === true ?
                                <CButton className="btn btn-warning" onClick={() => {
                                    this.handleUpdateProduct(index, true)
                                }}>Deshacer ubicación</CButton>
                                : ''}
                        </div>
                        {product.showHistory !== undefined && product.showHistory === true ?
                            <HistoryProduct history={product.history}/>
                            : ''}
                    </div> : ''}
                    {inventory && product.inventory.length > 0 ?
                        <div className="mt-3 product-action">
                            <div className="text-start">
                                <CButton className="btn btn-secondary" onClick={() => {
                                    this.handleHistoryInventory(index)
                                }}>Ver histórico inventario
                                </CButton>
                            </div>
                            {product.showInventory !== undefined && product.showInventory === true ?
                                <InventoryProduct inventory={product.inventory}/>
                                : ''}
                        </div>
                    : ''
                    }


                </div>
            </li>
        );
    }
}

export default Product;